import Spinner from './spinner.vue'
import Dots from './dots.vue'

export default {
  Spinner,
  Dots
}



// WEBPACK FOOTER //
// ./src/components/internal/loader/loaders/index.js